import {
	FormItem,
	ValidationError
} from "client/Components";
import { IValueInputAttachable } from "client/Forms/attachable";
import { localize } from "client_legacy/ndaw/culture";
import { ReactElement, useCallback } from "react";
import { UsersAndUserGroupsDataModel } from "client/Api/UserGroupsManagement/userGroupsManagement";
import {
	UserAndUserGroupCollection,
	UserAndUserGroupCollectionValue,
	UserAndUserGroupKind
} from "client/Features/Users/UserAndUserGroupCollection/UserAndUserGroupCollection";
import { ActiveTab } from "client/Features/Users/UserAndUserGroupTabSelector/UserAndUserGroupTabSelector";
import { PermissionSetModel } from "client/Api/common";
import { attachToUserAndUserGroupCollection } from "client/Features/Users/UserAndUserGroupCollection/attachable";

export type OwnersProps = {
	attachable: IValueInputAttachable<PermissionSetModel>;
	usersAndUserGroupsData: UsersAndUserGroupsDataModel;
	onChanged: (
		oldValue: PermissionSetModel,
		newValue: PermissionSetModel
	) => void;
};

export const Owners = (props: OwnersProps): ReactElement => {
	const {
		attachable,
		usersAndUserGroupsData,
		onChanged
	} = props;

	const currentValue: PermissionSetModel = attachable.value;

	const changedHandler = useCallback(
		(newValue: UserAndUserGroupCollectionValue): void => {
			onChanged(
				currentValue,
				newValue,
			);
		},
		[onChanged, currentValue]
	);

	return (
		<FormItem height="stretch">
			<UserAndUserGroupCollection
				{...attachToUserAndUserGroupCollection(
					attachable,
					{
						kind: UserAndUserGroupKind.Edit,
						dialogTitleWhenAddingUsersAndUserGroups: localize("_AddGroupsOrUsers")
					},
					changedHandler
				)}
				activeTab={ActiveTab.UserGroup}
				allUsersAndUserGroupsData={usersAndUserGroupsData}
			/>

			<ValidationError {...attachable.attachToValidationError()}/>
		</FormItem>
	);
};
Owners.displayName = "Owners";